// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jOBImMoZIYI1aNa0jWdA{width:100%}.kHoAbn1GCEuslTeczhAz{margin-top:40px}.h3u6eooAx0U17x21nE6Z,.QDvs6mVHAd0cn3kcskPS{margin-top:32px}.q3NKdZNGNXIT9PhZ5wGY{font-size:13px;line-height:normal}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `jOBImMoZIYI1aNa0jWdA`,
	"messageFlowField": `kHoAbn1GCEuslTeczhAz`,
	"optOutField": `h3u6eooAx0U17x21nE6Z`,
	"sampleField": `QDvs6mVHAd0cn3kcskPS`,
	"fieldText": `q3NKdZNGNXIT9PhZ5wGY`
};
export default ___CSS_LOADER_EXPORT___;
